import React, {useState, useEffect, useLayoutEffect, useRef} from 'react';
import './ret.css';
import { useLocation, useParams, Link } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
const Hoon =()=>{
    const {way : jikap} = useParams();
    const neyong = useLocation();
    const [pac, setpac] = useState();
    const [momo, setmomo] = useState(neyong.state);
  

    useEffect(()=>{
        const fetch = async()=>{
            const hoakin = await axios.get(`/api/titi?single=${jikap}`).then(kip=>{setpac(kip.data)})
            .catch(err=>{
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
        
        fetch();
    
    },[jikap]);

    useLayoutEffect(()=>{
        const fetca = async()=>{
            const kakad = await axios.get(`/api/fonja?single=${jikap}`).then(kp =>{setmomo(kp.data)}).catch(err=>{
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
        const fetka = async()=>{
            const forty = await axios.get(`/api/fonjone?single=${jikap}`).then(kp =>{setmomo({...momo, hit : momo.hit+1})}).catch(err=>{
                if(err.response?.data?.condition === "outofrange"){
                    alert("요청하신 페이지는 존재하지 않아요");
                };
            });
        };
       
        if(neyong?.state == null){
            fetca();
         
        }else{
            fetka();
           
        };
        window.scrollTo(0,0);
        document.title = `돌파 결과 - ${momo?.title}`
    },[jikap]);

    return(
        <>
        <p>실력 향상을 이뤄냈습니다!! 돌파 기록은 성취입니다!!</p>
        <p>돌파의 결실을 돌파공모에 남겨주세요</p>
        <div>
            <p>돌파공모는 여러분의 성취를 응원하며, 결코 포기하지 않고 도전을 즐기는 모습을 너무나도 환영합니다.</p>
            <p>자랑스러운 수상 이력은 도전의 부스터, 돌파를 향한 저력 넘치는 에너지로 우리를 추동합니다.</p>
            <p>적극적으로 도전하고, 그에 대한 성취 기록을 돌파공모인들에게 알려주세요!!</p>
            <p>공모전을 통해 우리 모두 발전할 수 있습니다.</p>
        </div>
        <p>성취 이력은 개인 페이지 내 수정 요청으로 입력할 수 있어요.</p>
        <div className='success'>
            <h2>돌파 결과</h2>
            <p className='succ1'>{momo?.title}</p>
            <p className='succ1'>{momo?.prize}</p>
            <div className={isMobile ? 'succ4' : 'succ2'}>
             <p className='succ3'>{momo?.name}</p>
             <p className='succ3'>{dayjs(momo?.date).format('YYYY-MM-DD')}</p>
             <p className='succ3'>HIT {momo?.hit}</p>
            </div>
        </div>
        <Link to="/hika" onClick={()=>window.history.replaceState({page : window.history.state.page},null,null)} className='nocolor'>목록</Link>
        {/* {pac?.has !== null && <div><span><Link to={`/hika/${pac?.has}`} state="undy">이전글</Link></span><span>{pac?.hus}</span></div>}
        {pac?.las !== null && <div><span><Link to={`/hika/${pac?.las}`} state="undy">다음글</Link></span><span>{pac?.lus}</span></div>}  */}
        </>
    )

}

export default Hoon;